<template>
  <div class="main-content">
    <div v-if="stores && selectedStore">
      <div class="card">
        <div class="card-header">
          <h5>Настройка складов</h5>
        </div>
        <div class="card-body">
          <div class="row">
            <div class="col-md-3">
              <div class="form-group">
                <label for="">Склад</label>
                <select @change="getStores(false)" v-model="selectedStore" class="form-control">
                  <option v-for="(store, index) in stores" :value="store">{{ store.title }} ({{ store.id }})</option>
                </select>
              </div>
            </div>
            <div class="col-md-3">
              <div class="form-group">
                <label for="">Название</label>
                <input v-model="selectedStore.title" type="text" class="form-control">
              </div>
            </div>
            <div class="col-md-2">
              <div class="form-group">
                <label for="">Сокращение</label>
                <input v-model="selectedStore.short_title" type="text" class="form-control">
              </div>
            </div>
            <div class="col-md-4">
              <div class="form-group">
                <label for="">Адрес</label>
                <input v-model="selectedStore.address" type="text" class="form-control">
              </div>
            </div>
          </div>
          <div class="form-check">
            <label class="form-check-label pointer">
              <input type="checkbox" v-model="selectedStore.is_active" class="form-check-input"> Склад активен
            </label>
          </div>
        </div>
      </div>

      <div class="card">
        <div class="card-header">
          <h6>Допустимы перемещения со складов</h6>
        </div>
        <div class="card-body">
          <div class="flex flex-wrap">
            <div class="store_directions" v-for="(store, index) in stores"
                 v-if="store.is_active && store.id !== selectedStore.id">
              <template v-if="allowedToReceiveFrom[store.id]">
                <span class="badge badge-primary">{{ store.title }}</span>
              </template>
              <template v-else>
                {{ store.title }}
              </template>
            </div>
          </div>
        </div>
      </div>

      <div class="card">
        <div class="card-header">
          <h6>Допустимые перемещения на склады</h6>
        </div>
        <div class="card-body" v-if="allowedToSend">
          <div class="">
            <table class="table table-sm table-hover">
              <thead>
              <tr>
                <th>Склад</th>
                <th>Срок по умолчанию (дней) не считая текущего</th>
                <th>Время</th>
                <th>Отправка</th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="(store, index) in sortRecords(stores, 'title')"
                  v-if="store.is_active && store.id !== 4 && store.id !== selectedStore.id">
                <td>
                  <div class="form-check">
                    <label class="form-check-label pointer">
                      <input type="checkbox" v-model="allowedToSend[store.id].active" class="form-check-input">
                      {{ store.title }} ({{ store.id }})
                    </label>
                  </div>
                </td>
                <td>
                  <select class="form-control" v-model="allowedToSend[store.id].days">
                    <option value="0" disabled>не указан</option>
                    <option v-for="i in 15" :value="i+1">{{ i + 1 }}</option>
                  </select>
                </td>
                <td>
                  <select class="form-control" v-model="allowedToSend[store.id].time">
                    <option v-for="index in 24" :value="`${('0' + (index - 1)).slice(-2)}:00`">
                      {{ ('0' + (index - 1)).slice(-2) }}:00
                    </option>
                  </select>
                </td>
                <td>
                  <button @click="addSendSchedule(store.id)" class="btn btn-default btn-xs">Добавить отправку</button>
                  <div v-if="sendSchedule[store.id] && sendSchedule[store.id].length">
                    <div v-for="(s,i) in sendSchedule[store.id]" class="input-group">
                      <select v-model="s.dayOfWeek" class="form-control">
                        <option :value="d.id" v-for="d in daysOfWeek">{{ d.title }}</option>
                      </select>
                      <div class="input-group-append">
                        <button class="btn btn-outline-danger" @click="removeSendSchedule(store.id, i)" type="button">
                          <i class="icon-fa icon-fa-trash"/>
                        </button>
                      </div>
                    </div>
                  </div>
                </td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>

      <div class="card">
        <div class="card-body">
          <div>
            <div class="form-check">
              <label class="form-check-label pointer">
                <input type="checkbox" v-model="allowedToReceiveInvoiceIncome" class="form-check-input"> Допустимо
                поступление препаратов извне от поставщиков (создавать накладные поступления)
              </label>
            </div>
            <hr>
            <div class="row">
              <div class="col-md-6">
                <div class="form-group">
                  <label for="">Количество дней для просчета (потенциально) проблемных заявок</label>
                  <input type="text" v-model="daysForConflictsOrders" class="form-control">
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>

      <div class="text-right">
        <vue-ladda button-class="btn btn-success btn-sm" data-style="zoom-in"
                   @click="saveStoreData()"
                   :loading="updateStoreDataLoading">Сохранить
        </vue-ladda>
      </div>


    </div>
  </div>
</template>


<script>

import api from '@/api'
import VueLadda from 'vue-ladda/src/vue-ladda.vue'

export default {
  components: {
    VueLadda,
  },
  data() {
    return {
      updateStoreDataLoading: false,
      stores: null,
      selectedStore: null,
      allowedToReceiveFrom: {},
      allowedToSend: null,
      allowedToReceiveInvoiceIncome: false,
      daysForConflictsOrders: 0,
      sendSchedule: {},
      daysOfWeek: [
        {id: 1, title: 'Понедельник'},
        {id: 2, title: 'Вторник'},
        {id: 3, title: 'Среда'},
        {id: 4, title: 'Четверг'},
        {id: 5, title: 'Пятница'},
        {id: 6, title: 'Суббота'},
        {id: 7, title: 'Воскресенье'},
      ],
    }
  },
  mounted() {
    this.getStores();
  },
  methods: {
    sortRecords(records, field) {
      return _.orderBy(records, field);
    },
    removeSendSchedule(storeId, index) {
      delete this.sendSchedule[storeId][index];
      this.sendSchedule[storeId] = this.sendSchedule[storeId].filter((s) => s);
      this.sendSchedule = {...this.sendSchedule};
    },
    addSendSchedule(storeId) {
      if (!this.sendSchedule[storeId]) this.sendSchedule[storeId] = [];
      this.sendSchedule[storeId].push({
        dayOfWeek: 1,
        is_regularly: true,
      });
      this.sendSchedule = {...this.sendSchedule};
    },
    resetOptions() {
      this.allowedToReceiveFrom = {};
      this.allowedToSend = {};
      this.sendSchedule = {};
      this.allowedToReceiveInvoiceIncome = false;
      this.allowedDirectUpload = false;
      this.stores.forEach((s) => {
        this.$set(this.allowedToSend, s.id, {
          active: false,
          days: 0,
          time: '00:00'
        });
      })

    },
    async saveStoreData() {
      this.updateStoreDataLoading = true;
      const {data} = await api.post('/settings/updateStoreData', {
        store: this.selectedStore,
        settings: {
          general: {
            sendSchedule: this.sendSchedule,
            allowedToSend: this.allowedToSend,
            allowedToReceiveInvoiceIncome: this.allowedToReceiveInvoiceIncome,
            daysForConflictsOrders: this.daysForConflictsOrders,
          }
        }
      });

      if (data.success) {
        await this.updateStoreData(true);
        toastr['success'](data.message || 'Обновлено');
        this.selectedStore = {...this.selectedStore};
      } else {
        toastr['warning'](data.message || 'Ошибка сохранения');
      }

      this.updateStoreDataLoading = false;
    },
    async updateStoreData(original = false) {
      if (!original) {
        this.resetOptions();
      } else {
        this.stores.forEach((s) => {
          if (s.id === this.selectedStore.id) {
            s.is_active = this.selectedStore.is_active;
          }
        })
      }
      this.selectedStore.settings.forEach((s) => {
        switch (s.option) {
          case 'sendSchedule':
            this.sendSchedule = {...s.sub_value};
            break;
          case 'daysForConflictsOrders':
            if (original) {
              s.value = this[s.option];
            } else {
              this[s.option] = s.value;
            }
            break;
          case 'allowedToReceiveInvoiceIncome':
            if (original) {
              s.value = this[s.option];
            } else {
              this[s.option] = s.value == 0 ? false : true;
            }
            break;
          case 'allowedToSend':
            let Opts = {};
            if (original) {
              Object.keys(this[s.option]).forEach((k) => {
                if (this[s.option][k].active) Opts[k] = this[s.option][k];
              });
            } else {
              Object.keys(s.sub_value).forEach((storeId) => {
                this[s.option][storeId] = s.sub_value[storeId];
              })
            }
            if (original) s.sub_value = Opts;
            break;
          case 'allowedToReceiveFrom':
            let arr = [];
            if (original) {
              Object.keys(this[s.option]).forEach((k) => {
                if (this[s.option][k]) arr.push(k);
              });
            } else {
              if (s.sub_value) {
                console.log(s.sub_value);
                (s.sub_value || []).forEach((v) => {
                  this[s.option][v] = true;
                })
              }
            }
            if (original) s.sub_value = arr;
            break;
        }
      })
      console.log('update');
    },
    async getStores(selectStore = true) {
      const {data} = await api.index('/settings/getStores');
      let myPromise = new Promise(async (resolve, reject) => {
        this.stores = _.orderBy(data.stores.filter((s) => s.is_active), 'title');
        if (selectStore) {
          this.selectedStore = data.stores[0];
        } else {
          this.selectedStore = {...this.selectedStore}
        }
        resolve({success: false});
      });
      const updating = await myPromise;
      this.updateStoreData();
    }
  }
}

</script>


<style scoped>
.store_directions {
  flex: 1 0 33%;
}
</style>

